/**
 * Links out to a maps app.
 *
 * We removed the in-app map, so this is how someone actually gets to the yard.
 * Google's universal URL format is deliberate: on a phone it hands off to the
 * installed Maps app, on a desktop it opens the web version, and it needs no
 * API key or embedded script — which is the whole reason the built-in map was
 * a blank grid in the first place.
 */

const hasCoords = (lat, lng) => Number.isFinite(Number(lat)) && Number.isFinite(Number(lng));

/** Drop a pin at the coordinates. Used to check a location. */
export function mapPinUrl(lat, lng) {
  if (!hasCoords(lat, lng)) return null;
  return `https://www.google.com/maps/search/?api=1&query=${Number(lat)},${Number(lng)}`;
}

/**
 * Turn-by-turn to the coordinates.
 *
 * Routed by coordinate rather than by street address on purpose: a storage
 * yard's gate is often not where the postal address pin lands, and arriving at
 * the wrong side of a fence towing forty feet of trailer is a genuinely bad
 * afternoon. The address rides along as a label so the destination is
 * recognisable when it appears.
 */
export function directionsUrl(lat, lng, label = null) {
  if (!hasCoords(lat, lng)) return null;
  const base = `https://www.google.com/maps/dir/?api=1&destination=${Number(lat)},${Number(lng)}`;
  return label ? `${base}&destination_place_id=&dir_action=navigate&query=${encodeURIComponent(label)}` : base;
}

/** Props for any anchor that leaves the site. */
export const externalLink = { target: '_blank', rel: 'noopener noreferrer' };
